exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2acf79DzX8mWN2OjVq5LZk{color:#0087e6;-webkit-text-decoration-line:none;-moz-text-decoration-line:none;text-decoration-line:none;white-space:nowrap}.MZXp5gdcDzikofnjM1JYo{text-align:left}._24EqeH6lIdbIP4iURyRSdr{padding-bottom:.71429rem}._1appiifmPAK3hyXxocPWPA{margin-left:.71429rem}._9Sa-38J86djX7OuuXcqR7{margin:0;padding-left:0;padding-top:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OnlineUsage_spinLink": "_2acf79DzX8mWN2OjVq5LZk",
	"OnlineUsage_popup": "MZXp5gdcDzikofnjM1JYo",
	"OnlineUsage_popup_name": "_24EqeH6lIdbIP4iURyRSdr",
	"OnlineUsage_popup_name_label": "_1appiifmPAK3hyXxocPWPA",
	"OnlineUsage_popup_ul": "_9Sa-38J86djX7OuuXcqR7"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Homework/OnlineUsage/style.postcss
// module id = 1648
// module chunks = 0